import { TextFieldDefinitionLogicBase } from './text-logic-base';

export class EditorNameFieldDefLogic extends TextFieldDefinitionLogicBase {
    // Constructor.
    public constructor() {
        super();
    };

    public getDefaultMaxLengthWhenInGrid(): number {
        return 250;
    }

    public includeInFormTemplateInstancesGrid(): boolean {
        return true;
    }

    public get canParticipateInFlexFieldBehavior(): boolean {
        return false;
    }
}
